var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21679 6.00803L0.559787 2.35103C0.486699 2.28448 0.427708 2.20393 0.386304 2.11417C0.344901 2.02441 0.321927 1.92725 0.318743 1.82845C0.315558 1.72965 0.332228 1.63121 0.367765 1.53897C0.403303 1.44673 0.456985 1.36255 0.525635 1.29143C0.594285 1.2203 0.676507 1.16367 0.767433 1.12489C0.85836 1.08611 0.956143 1.06596 1.05499 1.06565C1.15384 1.06533 1.25175 1.08485 1.34293 1.12305C1.4341 1.16125 1.51668 1.21735 1.58579 1.28803L1.60379 1.30603L5.78379 5.48503C5.92234 5.62362 6.00018 5.81156 6.00018 6.00753C6.00018 6.2035 5.92234 6.39145 5.78379 6.53003L1.60479 10.709C1.53735 10.7788 1.45683 10.8347 1.36782 10.8733C1.27881 10.912 1.18305 10.9328 1.08602 10.9345C0.988978 10.9361 0.892562 10.9187 0.802271 10.8831C0.711981 10.8475 0.629585 10.7945 0.559787 10.727C0.48999 10.6596 0.434158 10.5791 0.395479 10.4901C0.3568 10.4011 0.336032 10.3053 0.334361 10.2083C0.332689 10.1112 0.350147 10.0148 0.385737 9.92452C0.421327 9.83423 0.474353 9.75183 0.541787 9.68203L0.559787 9.66403L4.21679 6.00803Z",
    fill: "#6F1DF4",
    stroke: "#6F1DF4",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.fa6cc804a8e4c808cbef06ccd78ff013.svg";
export { ForwardRef as ReactComponent };